import { api } from './client';

export const AdminAPI = {
  summary: () => api.get('/admin/summary'),
  usageDaily: (days=30) => api.get('/admin/usage/daily', { params: { days } }),
  topEnterprises: (limit=10) => api.get('/admin/top-enterprises', { params: { limit } }),
  getAllAlerts: (type='all') => api.get('/admin/alerts', { params: { type } }),
  getCloudAlerts: () => api.get('/admin/cloud-alerts'),
  getEnterpriseStats: () => api.get('/admin/enterprises/stats'),
  getEnterprisePortfolio: (params) => api.get('/admin/enterprises/portfolio', { params }),
  getDashboardOverview: (days = 30) => api.get('/admin/dashboard-overview', { params: { days } }),
  getPartners: () => api.get('/admin/partners'),
  createPartner: (data) => api.post('/admin/partners', data),
  getPartnerDetails: (id) => api.get(`/admin/partners/${id}/details`),
  getPartnerInvoices: (id) => api.get(`/admin/partners/${id}/invoices`),
  getAllPartnerInvoices: (params) => api.get('/admin/partner-invoices', { params }),
  createPartnerInvoice: (id, data) => api.post(`/admin/partners/${id}/invoices`, data),
  getPartnerDashboard: () => api.get('/me/partner-dashboard'),
  getEnterpriseDetails: (id) => api.get(`/admin/enterprises/${id}/details`),
  sendAlert: (id, data) => api.post(`/admin/enterprises/${id}/notify`, data),
  // Revenue and Transactions
  getAllTransactions: (params) => api.get('/admin/transactions', { params }),
  getRevenueDashboard: () => api.get('/admin/revenue'),
  getAllReferrals: (params) => api.get('/admin/referrals', { params }),
  getAllCreditTransactions: (params) => api.get('/admin/credits', { params }),
  usageRecords: (days = 30) => api.get('/admin/usage/records', { params: { days } }),
  getSupportTickets: (filters = 'ALL') => api.get('/admin/support/tickets', { params: typeof filters === 'string' ? { status: filters } : filters }),
  updateSupportTicket: (id, payload) => api.patch(`/admin/support/tickets/${id}`, payload),
  broadcastNotification: (payload) => api.post('/admin/notifications/broadcast', payload),
  communications: () => api.get('/admin/communications'),
  createCommunication: (payload) => api.post('/admin/communications', payload),
  platformHealth: (status) => api.get('/admin/platform-health', { params: status ? { status } : {} }),
  updatePlatformHealth: (id, payload) => api.patch(`/admin/platform-health/${id}`, payload),
};
